import DiagramType from "../../../../../logic/components/Diagram/DiagramType";
import parseDiagramInfo from "./parseDiagramInfo";

const isDiagramName = (info: string): boolean => {
	const { name } = parseDiagramInfo(info);
	return name in DiagramType;
};

export default isDiagramName;
